import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles(() => ({
  button: {
    width: '217px',
  },
}))

export default useStyles
